import React, { useEffect, useState } from "react";
import Swiper from "../Components/Swiper";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import axios from "../Config/axios";

function Locations() {
  const [location, setLocation] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    axios
      .get("branch/get")
      .then((res) => {
        let { code } = res.data;

        if (code === 200) {
          setLocation(res?.data?.data?.branch);
        } else if (code === 400) {
          setLocation(res?.data?.data?.branch);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.outerWidth <= 768); // Adjust the breakpoint according to your needs
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={`background ${isMobile ? "header-placement" : ""}`}>
      {!isMobile && <Swiper />}
      <Navbar activeLink="locations" />
      <div className="home-title">Салбарууд</div>
      <div className="branch-wrapper">
        <div className="row">
          {location &&
            location.map((el, index) => (
              <div key={index} className="col-sm-6 col-md-4 mb-4">
                <img src={el.image_url} alt="" />
              </div>
            ))}
        </div>
      </div>
      <Footer isMobile={isMobile} />
    </div>
  );
}

export default Locations;
